import ChevronDownIcon from "@atlaskit/icon/core/chevron-down";
import {AnankeText} from "@vesta/ananke/components/anankeText";

const LIFECYCLE_TAB_FILTER_LABELS = ["Date Range", "Lifecycle", "Event Type", "Event status"] as const;

function ProfileLifecycleFilterPill({label}: {label: string}) {
    return (
        <button
            type="button"
            disabled
            className="inline-flex min-w-0 shrink-0 cursor-default items-center gap-x-ds-space-050 rounded-[4px] border border-solid border-ds-border bg-ds-surface px-ds-space-100 py-ds-space-075"
        >
            <AnankeText size="small">{label}</AnankeText>
            <ChevronDownIcon label="" size="small" />
        </button>
    );
}

export function ProfileLifecycleTabFilters() {
    return (
        <div className="flex w-full min-w-0 flex-wrap items-center gap-ds-space-100">
            {LIFECYCLE_TAB_FILTER_LABELS.map((label) => (
                <ProfileLifecycleFilterPill key={label} label={label} />
            ))}
        </div>
    );
}
